// Note that this does not include the start and end characters, so it you want to test the whole string, use this:

const EMAIL_REGEX = /^\w[-+.%'~\w]*@[a-zA-Z\d]+([-.][a-zA-Z\d]+)*\.[a-zA-Z\d]+([-.][a-zA-Z\d]+)*$/;
const EMAIL_REGEX_ALL = /\w[-+.%'~\w]*@[a-zA-Z\d]+([-.][a-zA-Z\d]+)*\.[a-zA-Z\d]+([-.][a-zA-Z\d]+)*/g;

export { EMAIL_REGEX, EMAIL_REGEX_ALL };
